import React from 'react';

import { DelayedImpressionObserver } from 'reaxl-analytics';

function CardContentWithAnalytics({ cardType, handleContentImpression = () => { }, listingId, children }) {
    return (
        <DelayedImpressionObserver
            onChange={() => handleContentImpression(cardType)}
            key={`${cardType}-resources-${listingId}-delayed-impression-observer`}
            delay={0}
        >
            {children}
        </DelayedImpressionObserver>
    );
}

export default CardContentWithAnalytics;
